// ============================================================================
// UNIFIED VEHICLE SUBSCRIPTION HOOK
// ============================================================================
// Dispatches to either WebSocket or Firebase RDB based on the app config's
// `connectionType` setting. Resolved once at module load time so the hook
// call is unconditional (React rules of hooks).
//
// connectionType: "websocket" → useVehiclesSocketSubscription (default)
// connectionType: "rdb"       → useVehiclesRdbSubscription
// ============================================================================

import { getConnectionType } from "../config/appsConfig";
import { useVehiclesSocketSubscription } from "./useVehiclesSocketSubscription";
import { useVehiclesRdbSubscription } from "./useVehiclesRdbSubscription";

const connectionType = getConnectionType();

/**
 * Unified hook that subscribes to real-time vehicle positions.
 * The underlying transport (WebSocket or Firebase RDB) is determined
 * by the `connectionType` field in the active app config JSON.
 */
export const useVehiclesSubscription =
  connectionType === "rdb"
    ? useVehiclesRdbSubscription
    : useVehiclesSocketSubscription;

export default useVehiclesSubscription;
